import _         from 'lodash'
import moment    from 'moment'
import Immutable from 'immutable'

# CONSIDER:
# - should we move serialization logic to serializers?
# - it obviously has design advantages and it could simplify Relation, if we pull stuff like
#   deserializeOne and deserializeMany from there as well
# - but is it practical at this point?

export default class Model
  with: (params) ->
    # FIXME: assign and extend lose properties defined by Object.defineProperty, cloneDeep even
    # loses nested ones
    _.assign(_.cloneDeep(@), params)

  @primaryKey: 'id'
  @nominativeName: 'not given'
  @accusativeName: 'not given'
  @onlyAttrs: null

  Object.defineProperty(@::, 'pk',         get: -> @[@constructor.primaryKey])
  Object.defineProperty(@::, 'attributes', get: -> _.omit(@, 'associations'))

  @with: (params) ->
    (new @).with(params)

  @attrNameMapping: {}

  @serialize: (instance) ->
    # TODO: require each model to define @attributes list and map over these
    # this way we won't overwrite associations, etc.
    # add @foreignKeys - will utomatically append ID to these attributes

    attrs = _.omit(instance, 'associations', 'createdAt', 'updatedAt')
    attrs = _.pick(attrs, @onlyAttrs) if @onlyAttrs

    @attrsToBackendNames(attrs)

  @deserialize: (row) ->
    row   = _.omit(row, 'links')
    attrs = @attrsToFrontendNames(row)

    attrs.createdAt = moment(row.created_at) if row.created_at
    attrs.updatedAt = moment(row.updated_at) if row.updated_at

    attrs = _.pick(attrs, @onlyAttrs) if @onlyAttrs

    @with(attrs)

  @attrsToFrontendNames: (row) ->
    _.mapKeys(row, (val, field) => @frontendNameFor(field))

  @attrsToBackendNames: (instance) ->
    _.mapKeys(instance, (val, attr) => @backendNameFor(attr))

  @backendNameFor: (attribute) ->
    @attrNameMapping[attribute] or _.snakeCase(attribute)

  @frontendNameFor: (attribute) ->
    _.invert(@attrNameMapping)[attribute] or _.camelCase(attribute)
